import { Col, Divider, Form, Input, Row, Select, Typography } from "antd";
import { BOM } from "../../../../../services/definedMethod";
const { Title, Text } = Typography;

const ReconcilationAndControlForm = (props) => {
  const { onFinish, form, formData, templateData } = props;

  const reconciliationRequired = Form.useWatch("reconciliationRequired", form);

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Reconciliation & Control
        </Title>
      </Divider>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="controlAccountFlag"
            label={<Text strong>Control Account Flag</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Control Account Flag"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Control Account Flag")}
              options={templateData.controlAccountFlagOptions}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="reconciliationRequired"
            label={<Text strong>Reconciliation Required</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Reconciliation Required"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Reconciliation Required")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>
        {reconciliationRequired === true && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="externalReconciliationCode"
              label={<Text strong>External Reconciliation Code</Text>}
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld("External Reconciliation Code"),
                },
              ]}
            >
              <Input
                placeholder={BOM.handlePlaceholderMsg(
                  "External Reconciliation Code",
                )}
              />
            </Form.Item>
          </Col>
        )}

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="settlementFlag"
            label={<Text strong>Settlement Flag</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Settlement Flag"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Settlement Flag")}
              options={templateData.externalSettlementAccount}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ReconcilationAndControlForm;
